module.exports = __webpack_public_path__ + "static/media/sweet_6.1007cfca.png";